const state = () => ({
    keys: {
        lastCompany: 'lastCompany',
        stateChip: 'state_chip_'
    },
});

const getters = {
    keyLastCompany: state => state.keys.lastCompany,
    keyStateChip: state => state.keys.stateChip,
    getSettings: (state) => (settings) => {
        let value = localStorage.getItem(settings);
        try {
            value = JSON.parse(value);
        } catch {}
        return value;
    },
    currentKey: (state) => {
        const currentKey = localStorage.getItem(state.keys.lastCompany);
        return currentKey;
    }  
};


const mutations = {};


const setSettings = ({ commit, state, dispatch }, {settings, value}) => {
    if (typeof(value) === 'object') {
        value = JSON.stringify(value);
    }
    localStorage.setItem(settings, value);
};

const removeSettings = ({ commit, state, dispatch }, {settings}) => {
    var value = localStorage.getItem(settings);
    if (value) {
        localStorage.removeItem(settings);
    }
};


const actions = {
    setSettings,
    removeSettings
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}